// extracted by mini-css-extract-plugin
export default {"cardBox":"styled_cardBox__8C8bX","iconBox":"styled_iconBox__FwVqn"};